export const AppError = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    APP_VERSION_CODE_DOWNGRADE: 'APP_VERSION_CODE_DOWNGRADE',
    SAME_AS_PUBLISHED_APP_VERSION_CODE: 'SAME_AS_PUBLISHED_APP_VERSION_CODE',
    NO_ESIA_PROFILE: 'NO_ESIA_PROFILE',
    PACKAGE_NAME_DIFF: 'PACKAGE_NAME_DIFF',
    PACKAGE_NAME_ALREADY_TAKEN: 'PACKAGE_NAME_ALREADY_TAKEN',
    APK_ILLEGAL_PERMISSIONS: 'APK_ILLEGAL_PERMISSIONS',
    INVALID_STRUCTURED_EXAMPLE: 'INVALID_STRUCTURED_EXAMPLE',
    INVALID_STRUCTURED_EXAMPLE_HAS_ACTIVATION_NAME: 'INVALID_STRUCTURED_EXAMPLE_HAS_ACTIVATION_NAME',
    APP_NAME_IS_TAKEN: 'APP_NAME_IS_TAKEN',
    APP_NAME_MIN_WORDS_LIMIT: 'APP_NAME_MIN_WORDS_LIMIT',
    APP_NAME_MAX_WORDS_LIMIT: 'APP_NAME_MAX_WORDS_LIMIT',
    INVALID_URL: 'INVALID_URL',
    ACTIVATIONS_PHRASES_SAME: 'ACTIVATIONS_PHRASES_SAME',
    ACTIVATIONS_PHRASES_GENERAL: 'ACTIVATIONS_PHRASES_GENERAL',
    ACTIVATIONS_PHRASES_MIN_WORDS_LIMIT: 'ACTIVATIONS_PHRASES_MIN_WORDS_LIMIT',
    ACTIVATIONS_PHRASES_MAX_WORDS_LIMIT: 'ACTIVATIONS_PHRASES_MAX_WORDS_LIMIT',
    ACTIVATIONS_PHRASES_IS_TAKEN: 'ACTIVATIONS_PHRASES_IS_TAKEN',
    CLOUD_FUNCTIONS_ARE_NOT_ALLOWED_FOR_OFFICIAL_SKILLS: 'CLOUD_FUNCTIONS_ARE_NOT_ALLOWED_FOR_OFFICIAL_SKILLS',
    MAX_LENGTH_LIMIT: 'MAX_LENGTH_LIMIT',
    FILE_SIZE_LIMIT: 'FILE_SIZE_LIMIT',
    FILE_WRONG_FORMAT: 'FILE_WRONG_FORMAT',
    FILE_NAME_IS_ABSENT: 'FILE_NAME_IS_ABSENT',
    INTENT_EMPTY_FORM_NAME: 'INTENT_EMPTY_FORM_NAME',
    INTENT_FORM_NAME_UNIQUE: 'INTENT_FORM_NAME_UNIQUE',
    SHARE_LIMIT_EXCEEDED: 'SHARE_LIMIT_EXCEEDED',
    PORGANISATION_IS_NOT_VERIFIED: 'PORGANISATION_IS_NOT_VERIFIED',
    NOT_ALL_DEVICES_SUPPORTED: 'NOT_ALL_DEVICES_SUPPORTED',
    MIN_SDK_VERSION_NOT_SUPPORTED: 'MIN_SDK_VERSION_NOT_SUPPORTED',
    APK_PARSE_ERROR: 'APK_PARSE_ERROR',
    APK_CHECK_FAILED: 'APK_CHECK_FAILED',
} as const;

export type TError = (typeof AppError)[keyof typeof AppError];

export interface ApiValidationError {
    key?: string;
    type: TError;
    arg?: Record<string, string | number>;
}
